<template>
  <div v-loading="loading">
    <draggerBox
      :menuList="menuList"
      @save="onSave"
      :loading="saveLoading"
      :type="type"
      :buttonName="type === 6 ? $t('storage::out-stock::add_in_type') : $t('storage::out-stock::add_out_type')"
    ></draggerBox>
  </div>
</template>
<script>
import { getDicByCode, postUpdateDicByCode } from '@/server/common'
import draggerBox from './dragger'
export default {
  name: 'ServiceCategory',
  components: {
    draggerBox
  },
  props: {
    type: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      loading: false,
      saveLoading: false,
      menuList: []
    }
  },
  mounted () {
    this.getListData()
  },
  methods: {
    async getListData (fn) {
      this.loading = true
      const { data } = await getDicByCode(this.type)
      this.loading = false
      if (data.code === this.$code) {
        this.menuList = data.data.map((item, i) => {
          return {
            ...item
          }
        })
        if (fn) fn()
      }
    },
    async onSave (items) {
      this.saveLoading = true
      const { data } = await postUpdateDicByCode({
        type: this.type,
        items: items.map((item, index) => {
          return {
            ...item,
            sequence: index
          }
        })
      })
      this.saveLoading = false
      if (data.code === this.$code) {
        this.getListData(() => this.$message.success(this.$t('system::tip::control_success')))
        this.$emit('closeDialog')
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
